<script lang="ts">
  import Button from '$components/elements/Button.svelte';
  import Text from '$components/utils/Text.svelte';
</script>

<div class="support-us">
  <div class="support-us__text">
    <h2 class="color-white"><Text key="component.support-us.heading" /></h2>
    <p class="color-white"><Text key="component.support-us.text" /></p>
  </div>
  <div class="support-us__button">
    <Button icon="arrow-right" iconColor="#fff" href="/klub-bible21#darujte">
      <Text key="component.support-us.button" />
    </Button>
  </div>
</div>

<style lang="scss">
  .support-us {
    background-color: $color-caramel;
    width: 80%;
    max-width: 1280px;
    margin: 100px auto 0;
    border-radius: 20px;
    display: grid;
    grid-template-columns: 1fr auto;
    gap: 25%;
    padding: 48px 120px 48px 50px;
    align-items: center;
    &__text {
      display: flex;
      flex-direction: column;
      gap: 24px;
      h2 {
        font-size: 36px;
        font-weight: 800;
      }
      p {
        font-size: 17px;
        line-height: 31px;
      }
    }
  }
  @media screen and (max-width: 850px) {
    .support-us {
      width: 100vw;
      border-radius: 0;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      padding: 40px 21px;
      gap: 30px;
      &__text {
        display: contents;
        p {
          text-align: center;
          max-width: 500px;
        }
      }
    }
  }
</style>
